export const NAV_ITEM_BOOKMARKS_GROUP_ID = '@@nav-item/bookmarks-group';
export const MAX_BOOKMARK_ITEMS = 10;